import { render } from "./adminfive.vue?vue&type=template&id=b419b1e2&scoped=true"
import script from "./adminfive.vue?vue&type=script&lang=js"
export * from "./adminfive.vue?vue&type=script&lang=js"

import "./adminfive.vue?vue&type=style&index=0&id=b419b1e2&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b419b1e2"]])

export default __exports__